import { getApiClient } from './authApiClient';

const client = () => getApiClient('tenant');

export const listQuickTasks = async (tenantId, assigneeUserId, options = {}) => {
  const response = await client().get(`/quick-tasks/${tenantId}`, {
    params: { ...(assigneeUserId ? { assigneeUserId } : {}), ...(options.includeClosed ? { includeClosed: true } : {}) },
  });
  return response.data;
};

export const listQuickTaskAssignees = async (tenantId) => {
  const response = await client().get(`/quick-tasks/${tenantId}/assignees`);
  return response.data;
};

export const createQuickTask = async (tenantId, task) => {
  const response = await client().post(`/quick-tasks/${tenantId}`, task);
  return response.data;
};

export const updateQuickTask = async (tenantId, taskId, patch) => {
  const response = await client().patch(`/quick-tasks/${tenantId}/${taskId}`, patch);
  return response.data;
};

export const deleteQuickTask = async (tenantId, taskId) => {
  const response = await client().delete(`/quick-tasks/${tenantId}/${taskId}`);
  return response.data;
};
